export default {
	props: {
		value: {
			required: true
		},
		recomendations: {
			type: Number,
			required: true
		},
		items: {
			type: Array,
			required: true
		},
		spaces: {
			type: Array,
			required: true
		},
		units: {
			type: String,
			default: 'metric',
			validator: function (value) {
				return ['metric', 'imperial'].indexOf(value) !== -1
			}
		},
	},
	data() {
		return {
			newRoomName: '',
			newItem: {},
			newQty: 0,
		}
	},
	computed: {
		rooms() {
			return this.value.map(room => {
				room.items.map(item => {
					if(typeof item.volume !== 'object') {
						item.volume = {
							metric: item.volume,
							imperial: this.toImperial(item.volume)
						}
					}
					this.$set(
						item,
						'totalVolume',
						{
							metric: (item.quantity * item.volume.metric).toFixed(2),
							imperial: this.toImperial((item.quantity * item.volume.metric).toFixed(2))
						}
					);
				})
				room.volume = {
					metric: this.roomVolume(room),
					imperial: this.toImperial(this.roomVolume(room))
				}
				return room
			})
		},
		recommendedSpaces() {
			return this.spaces.filter(space => space.volume >= this.totalVolume()[this.units]).slice(0, this.recomendations)
		},
	},
	updated() {
		this.$nextTick(function () {
			const event = new CustomEvent('estimate-updated', {detail: {rooms: [...this.value]}});
			document.dispatchEvent(event);
		});
	},
	methods: {
		addRoom() {
			if (this.newRoomName.trim().length === 0 || this.value.includes(this.newRoomName.trim())) {
				return
			}
			let payload = [...this.value, {name: this.newRoomName.trim(), items: []}];
			this.emitEvents(payload);
			this.newRoomName = ''
		},
		removeRoom(room) {
			let payload = this.value.filter(r => r !== room)
			this.emitEvents(payload);
		},
		addItem(room) {
			this.$set(this.newItem, 'quantity', 1)
			room.items.push(this.newItem)
			let payload = [...this.value];
			this.emitEvents(payload);
			this.newItem = {}
		},
		removeItem(room, item) {
			room.items.splice(room.items.indexOf(item), 1)
			let payload = [...this.value];
			this.emitEvents(payload);
		},
		changeQty(item) {
			item.quantity = this.newQty
			let payload = [...this.value];
			this.emitEvents(payload);
			this.newQty = 0
		},
		roomVolume(room) {
			return room.items.length > 0 ? room.items.reduce((a, b) => a + (b.volume.metric * b.quantity), 0).toFixed(2) : 0
		},
		totalVolume() {
			var volume = parseFloat(0)
			this.rooms.map(room => volume += +this.roomVolume(room))

			return {
				metric: volume.toFixed(2),
				imperial: this.toImperial(volume.toFixed(2))
			}
		},
		toImperial(value) {
			return Math.round(value * 35.3147 * 10) / 10
		},
		emitEvents(payload) {
			this.$emit('input', payload);
		}
	},
	render() {
		return this.$scopedSlots.default({
			loading: this.loading,
			items: this.items,
			spaces: this.spaces,
			rooms: this.rooms,
			recommendedSpaces: this.recommendedSpaces,
			addRoom: this.addRoom,
			removeRoom: this.removeRoom,
			addItem: this.addItem,
			removeItem: this.removeItem,
			changeQty: this.changeQty,
			roomVolume: this.roomVolume,
			totalVolume: this.totalVolume,
			addRoomAttrs: {
				value: this.newRoomName,
			},
			addRoomEvents: {
				input: (e) => { this.newRoomName = e.target.value },
				keydown: (e) => {
					if (e.keyCode === 13) {
						e.preventDefault()
						this.addRoom()
					}
				}
			},
			addItemAttrs: {
				value: this.newItem,
			},
			addItemEvents: (room) => {
				return {
					input: (e) => { this.newItem = JSON.parse(e.target.value) },
					change: (e) => {
						e.preventDefault()
						this.addItem(room)
					}
				}
			},
			changeQtyAttrs: (item) => {
				return {
					value: item.quantity,
				}
			},
			changeQtyEvents: (item) => {
				return {
					input: (e) => {
						this.newQty = parseInt(e.target.value) || 0
					},
					change: (e) => {
						e.preventDefault()
						this.changeQty(item)
					}
				}
			}
		})
	},
}